<template>
  <section> 
    <b-row>
      <b-col :cols="8">
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Enviar mensajes   
             </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">   

              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
      <b-col>
        <b-card
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Saldo   
             </div>          
          </template>
            <b-row align-h="between">
              <b-col style="margin-top:10px">  
                <div>
                  <b-icon variant="info" icon="file-text" scale="1.5"></b-icon>
                  150 sms 
                </div>                                        
              </b-col>   
              <b-col style="margin-top:10px" class="text-right">  
                <div>
                  <b-button  v-b-modal.modal-recargas variant="info" type="button" size="sm">Recargar</b-button>
                  <b-modal id="modal-recargas" title="Recargar sms">                         
                    <b-form-group label="Selecciona el valor de la recarga" v-slot="{ ariaDescribedby }">
                      <b-form-radio v-model="recargar" :aria-describedby="ariaDescribedby" name="some-radios" value="0">$ 20.000 - <span  class="font-weight-bold">250 sms</span></b-form-radio>
                      <b-form-radio v-model="recargar" :aria-describedby="ariaDescribedby" name="some-radios" value="1">$ 50.000 - <span class="font-weight-bold">750 sms</span></b-form-radio>
                      <b-form-radio v-model="recargar" :aria-describedby="ariaDescribedby" name="some-radios" value="2">$ 100.000 - <span class="font-weight-bold">1.800 sms</span></b-form-radio>
                      <b-form-radio v-model="recargar" :aria-describedby="ariaDescribedby" name="some-radios" value="3">$ 200.000 - <span class="font-weight-bold">4.500 sms</span></b-form-radio>
                    </b-form-group>
                    <template v-slot:modal-footer={hide}>
                      <div class="text-right">
                        <b-button @click="hide" variant="outline-secondary" size="md" class="mr-4">Cancelar</b-button>
                        <b-button variant="primary"  size="md">Solicitar</b-button>
                      </div>
                    </template>
                  </b-modal>
                </div>                                        
              </b-col>            
            </b-row>            
        </b-card>
        <b-card
          body-class="px-0"
          class="mt-5 px-0"
          style="max-width: 100%">
          <template v-slot:header >
            <div class="header-card text-left">
              Historial recargas   
             </div>          
          </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px" class="px-0">
                <b-table striped hover :items="historialTable"></b-table>                         
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalanularautorizar from '@/components/modals/anularAutorizar.vue'
import SwModalautorizar from '@/components/modals/autorizar.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalanularautorizar,
  SwModalautorizar     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

